import React from "react";

const RetailPresenceSubtitle: React.FC = () => {
    return (
        <>
            Get a quick overview of the stores in this Retail Zone.
            <br />
            Dash helps you understand how many stores there are,
            how many are independent, their typical size, and the
            breakdown of store categories across the area.
        </>
    );
};

export default RetailPresenceSubtitle;
